const ProductType = {
  TRIAL: "trial",
  KAVALAN_LIGHT: "kavalanLight",
  KAVALAN: "kavalan",
};

export default ProductType;
